export function getCommunityType(container) {
    let communityType = 1;

    // Detect if container is a jQuery object by checking for jQuery properties
    const isJQuery = container && typeof container.hasClass === 'function';

    // Helper function to check class depending on type
    const hasClass = (cls) => {
        if (isJQuery) {
            return container.hasClass(cls);
        } else if (container && container.classList) {
            return container.classList.contains(cls);
        }
        return false;
    };

    if (hasClass("event_entry")) {
        communityType = 6;
    } else if (hasClass("blog_entry")) {
        communityType = 5;
    } else if (hasClass("survey_entry")) {
        communityType = 7;
    }

    return communityType;
}
